import * as styles from "./NotesTab.css";

import type { JSX } from "react";

import {
  TextEditor,
  plainTextToHtml,
} from "@frontend/components/organisms/TextEditor";
import { useField } from "@frontend/hooks/form";
import { useLingui } from "@lingui/react/macro";

import { clientForm } from "../stores/editor";

const fields = clientForm.fields;

/**
 * The free notes the legacy form keeps beside the identity. A note saved
 * before the field held formatted text is read as plain text until someone
 * edits it.
 */
export function NotesTab(): JSX.Element {
  const { t } = useLingui();

  const comments = useField(fields.comments);

  return (
    <div className={styles.tab}>
      <TextEditor
        fill
        size="sm"
        toolbarVariant="ghost"
        ariaLabel={t`Notes`}
        value={plainTextToHtml(comments.value ?? "")}
        onValueChange={comments.setValue}
      />
    </div>
  );
}
